import React, { useState } from "react"
import GenericModal from "../generic-modal/generic-modal"
import SelectBirthDate from "../../molecules/select-birthdate/select-birthdate"
import UploadImage from "../../molecules/upload-image-change-birthdate/upload-image-change-birthdate"
import SelectMethodOtp from "../../molecules/select-method-otp/select-method-otp"
import ModalOTP from "../../molecules/otp-modal/otp-modal"
import ParentForm from "../../molecules/parent-form/parent-form"
import WarningModal from "../warning-modal/warning-modal"
import StandardModal from "../standard-modal/standard-modal"
import AuthService from "../../../services/auth-service"
import "./modal-change-birthdate.scss"
import DataPolicyService from "../../../services/datapolicy-service"
import UseChecksPolicy from "../../../hooks/useChecksPolicy"

const ModalChangeBirthday = ({ closeModal, logout }) => {
  const [step, setStep] = useState(0)
  const [newBirthdate, setNewBirthdate] = useState({
    year: "",
    month: "",
    date: "",
  })
  const [methodOtp, setMethodOtp] = useState()
  const [parentInfo, setParentInfo] = useState({})
  const [images, setImages] = useState([])
  const [errorImages, setErrorImages] = useState()
  const [isLoading, setisLoading] = useState()
  const [otpCode, setOtpCode] = useState()
  const [errorOtp, setErrorOtp] = useState()
  const [resendOtp, setResendOtp] = useState()

  const { getPayloadCheck } = UseChecksPolicy(true)

  const generateHeader = () => ({
    headers: {
      Authorization: JSON.parse(localStorage.getItem("TOKEN_INFO")).idToken,
    },
  })

  const saveNewBirthdate = value => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: "ga_event_consultorio",
      category: "Cambio Fecha Nacimiento :: ¿Quieres cambiar tu fecha?",
      action: "Click",
      label: "{{nombre botón}}",
      value: "",
    })

    setNewBirthdate({
      year: parseInt(value.year).toLocaleString("en-US", {
        minimumIntegerDigits: 4,
        useGrouping: false,
      }),
      month: parseInt(value.month).toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      }),
      day: parseInt(value.day).toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      }),
    })
    setStep(1)
  }

  const handleChangeImg = file => {
    setErrorImages(null)
    if (file) {
      const format = file.name
        .split(".")
        [file.name.split(".").length - 1].toLowerCase()
      if (file.size > 5242880) {
        setErrorImages("*El peso maximo de la imagen es 5MB")
      } else if (format !== "jpg" && format !== "jpeg" && format !== "png") {
        setErrorImages("*El formato de la imagen debe ser .jpg  .jpeg  .png  ")
      } else {
        setImages(images => images.concat(file))
      }
    }
  }

  const handeDelateImage = indexDelate => {
    setImages(images => images.filter((_, index) => index !== indexDelate))
  }

  const validateImagesDocument = async () => {
    try {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: "ga_event_consultorio",
        category: "Cambio Fecha Nacimiento :: ¿Quieres cambiar tu fecha?",
        action: "Click",
        label: "Siguiente",
        value: "",
      })
      setisLoading(true)
      const formData = new FormData()
      formData.append("imageFront", images[0])
      formData.append("imageBack", images[1])

      const config = {
        ...generateHeader(),
        params: {
          birthdate: `${newBirthdate.year}-${newBirthdate.month}-${newBirthdate.day}`,
        },
      }

      const res = await AuthService.validateBirthdate(formData, config)
      if (res.data.status == 200) {
        setStep(2)
      } else {
        setImages([])
        setStep(7)
      }
    } catch (e) {
      console.error(e)
    } finally {
      setisLoading(false)
    }
  }

  const sendOTP = async (method, isResendCode) => {
    try {
      if (isResendCode) {
        setResendOtp(true)
      } else {
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: "ga_event_consultorio",
          category: "Cambio Fecha Nacimiento :: Verificación",
          action: method,
          label: "Siguente",
          value: "",
        })
        setMethodOtp(method)
      }
      const config = generateHeader()
      await AuthService.sendOTP(method || methodOtp, config)
      setStep(3)
    } catch (e) {
      console.error(e)
    }
  }

  const validateOTP = async code => {
    try {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: "ga_event_consultorio",
        category: "Cambio Fecha Nacimiento :: Verificación",
        action: "Click",
        label: "Siguiente",
        value: "",
      })
      setisLoading(true)
      setResendOtp(false)
      const config = generateHeader()
      const res = await AuthService.validateOTP(code, config)
      if (res.status === 200) {
        validateAdult(code)
        setOtpCode(code)
      } else if (res.status === 400) {
        setErrorOtp(res.userMessage)
      }
    } catch (e) {
      console.error(e)
    }
  }

  const calculateAge = fecha => {
    var hoy = new Date()
    var edad = hoy.getFullYear() - parseInt(fecha.year)
    var m = hoy.getMonth() - parseInt(fecha.month)

    if (m < 0 || (m === 0 && hoy.getDate() < parseInt(fecha.date))) {
      edad--
    }
    return edad
  }

  const validateAdult = otp => {
    const newAge = calculateAge(newBirthdate)
    const isAdultNewAge = newAge >= 18
    const prevSrtBirthdate = JSON.parse(
      localStorage.getItem("USER_INFO")
    ).birthdate.split(" ")[0]

    const prevBirthdate = new Date(prevSrtBirthdate.replace(/-/g, "/"))
    const prevAge = calculateAge({
      year: prevBirthdate.getFullYear(),
      date: prevBirthdate.getDate(),
      month: prevBirthdate.getMonth() + 1,
    })

    const isAdultPrevAge = prevAge >= 18

    if (isAdultNewAge) {
      updateUserInfo(otp, true)
    } else if (!isAdultPrevAge) {
      updateUserInfo(otp, true)
    } else {
      setisLoading(false)
      setStep(4)
    }
  }

  const updateUserInfo = async (otp, isAdult) => {
    try {
      const userInfo = JSON.parse(localStorage.getItem("USER_INFO"))
      const config = generateHeader()
      const payload = {
        adult: userInfo.adult,
        cellPhone: userInfo.cellPhone,
        country: userInfo.country,
        location: {
          city: userInfo.location?.city || null,
          address: userInfo.location?.address || null,
          addressDetail: userInfo.location?.addressDetail || null,
        },
        email: userInfo.email,
        lastName: userInfo.lastName,
        name: userInfo.name,
        profilePicture: userInfo.profilePicture,
        codeDestination: "",
        otp: otp,
        birthDateChange: {
          birthDateNew: `${newBirthdate.year}-${newBirthdate.month}-${newBirthdate.day}`,
          cellPhone: `${process.env.COUNTRY_PHONE_PREFIX}${parentInfo.parentMethodValueConfirm}`,
          email: parentInfo.parentMethodValueConfirm,
          name: parentInfo.parentName,
          verificationMode: parentInfo.parentMethod,
        },
      }
      setisLoading(true)
      const res = await AuthService.updateAccount(payload, config)
      if (res.status === 200) {

        // update habeas data
        DataPolicyService.updatePolicy(getPayloadCheck(), config).then(res => {
          console.log("Habeas data update")
        })


        if (isAdult) {
          setStep(8)
        } else {
          setStep(6)
        }
      }
    } catch (e) {
      console.error(e)
    } finally {
      setisLoading(false)
    }
  }

  const saveParentInfo = values => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: "ga_event_consultorio",
      category: "Cambio Fecha Nacimiento :: Datos Acudiente",
      action: "Click",
      label: "Finalizar",
      value: "",
    })
    setParentInfo(values)
    setStep(5)
  }

  return (
    <GenericModal>
      <div className="f-modal-change-birthdate">
        <button
          className="icon2-close f-close-icon"
          onClick={() => {
            if (step === 6 || step === 8) {
              logout()
            }
            closeModal()
          }}
        />
        {step === 0 && (
          <SelectBirthDate
            onSubmit={saveNewBirthdate}
            closeModal={closeModal}
          />
        )}
        {step === 1 && (
          <UploadImage
            isLoading={isLoading}
            images={images}
            handleChangeImg={handleChangeImg}
            handeDelateImage={handeDelateImage}
            errorImages={errorImages}
            closeModal={() => {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: "ga_event_consultorio",
                category:
                  "Cambio Fecha Nacimiento :: ¿Quieres cambiar tu fecha?",
                action: "Click",
                label: "Cancelar",
                value: "",
              })
              closeModal()
            }}
            onClickNext={validateImagesDocument}
          />
        )}
        {step === 2 && <SelectMethodOtp onSubmit={sendOTP} />}
        {step === 3 && (
          <ModalOTP
            onClickSecondary={() => {
              setStep(2)
            }}
            setErrorOtp={setErrorOtp}
            setResendOtp={setResendOtp}
            resendOtp={resendOtp}
            onSubmit={validateOTP}
            handleResendCode={() => {
              sendOTP(null, true)
            }}
            secondaryButtonText="Elegir otro medio"
            errorOtp={errorOtp}
            isLoading={isLoading}
          />
        )}

        {step === 4 && (
          <ParentForm onSubmit={saveParentInfo} defaultValues={parentInfo} />
        )}
        {step === 5 && (
          <WarningModal
            title="¿Ingresaste bien los datos de tu acudiente?"
            description="Asegúrate que estén correctos, sin su aprobación no podrás continuar con el cambio de fecha de nacimiento"
            secondaryButtonText="Modificar"
            primaryButtonText="Finalizar"
            primaryButtonOnClick={() => {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: "ga_event_consultorio",
                category: "Cambio Fecha Nacimiento :: Confirmación Acudiente",
                action: "Click",
                label: "Finalizar",
                value: "",
              })
              updateUserInfo(otpCode, false)
              setStep(6)
            }}
            secondaryButtonOnClick={() => {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: "ga_event_consultorio",
                category: "Cambio Fecha Nacimiento :: Confirmación Acudiente",
                action: "Click",
                label: "Modificar",
                value: "",
              })
              setStep(4)
            }}
            noLayoutModal
          >
            <div className="f-confirm-parent">
              <p className="f-confirm-parent__text">
                Nombre acudiente: {parentInfo.parentName}
              </p>
              <p className="f-confirm-parent__text">
                Contacto: {parentInfo.parentMethodValue}
              </p>
            </div>
          </WarningModal>
        )}
        {step === 6 && (
          <StandardModal
            noLayoutModal
            noClose
            title="¡Estas muy cerca!"
            subtitle="SÓLO FALTA LA AUTORIZACIÓN DE TUS PADRES O ACUDIENTE"
            description="Una vez tus padres verifiquen tu información podrás ingresar a tu cuenta nuevamente"
            button_title="¡Estoy de acuerdo!"
            clickButton={() => {
              closeModal()
              logout()
            }}
          />
        )}

        {step === 7 && (
          <WarningModal
            title="Lo sentimos, no hemos podido validar los datos de tu fecha de nacimiento con las fotos"
            description={`Quizás las fotos no están claras, puedes intentar subirlas de nuevo. Si lo prefieres, comunicante con la Línea de Atención 01 800 052 4848 y te daremos una asesoría especial para ti.`}
            primaryButtonText="Finalizar"
            secondaryButtonText="Intentar de nuevo"
            secondaryButtonOnClick={() => {
              setStep(1)
            }}
            primaryButtonOnClick={() => {
              closeModal()
            }}
          />
        )}
        {step === 8 && (
          <StandardModal
            noLayoutModal
            noClose
            subtitle=""
            title="¡Tus datos se han actualizado con éxito!"
            description="Ya hemos guardado tus nuevos datos. Pronto aparecerán actualizados en tu perfil"
            button_title="¡Estoy de acuerdo!"
            clickButton={() => {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: "ga_event_consultorio",
                category: "Cambio Fecha Nacimiento :: Actualización",
                action: "Vista",
                label: "Exitosa",
                value: "",
              })
              closeModal()
              logout()
            }}
          />
        )}
      </div>
    </GenericModal>
  )
}

export default ModalChangeBirthday
